function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 384.97 384.97",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CF52"
    },
    d: "M347.77,90.305c20.19,0,37.18-16.31,37.2-36.41v277.18c0,20.11-16.3,36.41-36.41,36.41H28.23 c-6.66,0-12.06-5.4-12.06-12.05v-82.54H50c24.3,0,44-19.7,44-44c0-12.15-4.93-23.15-12.89-31.11 c-7.96-7.97-18.96-12.89-31.11-12.89H16.17v-82.54c0-6.65,5.4-12.05,12.06-12.05H40.6h29.6H346 C346,90.305,347.77,90.305,347.77,90.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB74B"
    },
    d: "M374.31,28.145c6.43,6.42,10.46,15.24,10.65,24.99c0.01,0.26,0.01,0.51,0.01,0.76 c-0.02,20.1-17.01,36.41-37.2,36.41H346v-34.82H70.2v-25.95c0-6.65,5.4-12.05,12.06-12.05h266.3 C358.62,17.485,367.72,21.565,374.31,28.145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB74B"
    },
    d: "M94,228.895c0,24.3-19.7,44-44,44H16.17H15.2c-8.39,0-15.2-6.8-15.2-15.2v-57.6 c0-8.4,6.81-15.2,15.2-15.2h0.97H50c12.15,0,23.15,4.92,31.11,12.89C89.07,205.745,94,216.745,94,228.895z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#008DB3"
    },
    points: "346,55.485 346,90.305 70.2,90.305 40.6,90.305 40.6,55.485 70.2,55.485  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#008DB3"
    },
    d: "M56,236.395c-0.49,0-0.98-0.05-1.46-0.15c-0.48-0.09-0.95-0.24-1.41-0.42 c-0.45-0.19-0.89-0.42-1.29-0.69c-0.41-0.28-0.8-0.59-1.14-0.94c-0.35-0.34-0.66-0.73-0.93-1.14c-0.27-0.4-0.51-0.84-0.69-1.29 c-0.19-0.45-0.34-0.93-0.43-1.4c-0.1-0.49-0.15-0.98-0.15-1.47s0.05-0.98,0.15-1.46c0.09-0.48,0.24-0.95,0.43-1.41 c0.18-0.45,0.42-0.89,0.69-1.29c0.27-0.41,0.58-0.8,0.93-1.14c0.34-0.35,0.73-0.66,1.14-0.93c0.4-0.28,0.84-0.51,1.29-0.69 c0.46-0.19,0.93-0.34,1.41-0.43c0.96-0.2,1.96-0.2,2.93,0c0.48,0.09,0.95,0.24,1.4,0.43c0.45,0.18,0.89,0.41,1.3,0.69 c0.41,0.27,0.79,0.58,1.14,0.93c0.34,0.34,0.65,0.73,0.93,1.14c0.27,0.4,0.5,0.84,0.69,1.29c0.18,0.46,0.33,0.93,0.42,1.41 c0.1,0.48,0.15,0.97,0.15,1.46s-0.05,0.98-0.15,1.47c-0.09,0.47-0.24,0.95-0.42,1.4c-0.19,0.45-0.42,0.89-0.69,1.29 c-0.28,0.41-0.59,0.8-0.93,1.14c-0.35,0.35-0.73,0.66-1.14,0.94c-0.41,0.27-0.85,0.5-1.3,0.69c-0.45,0.18-0.92,0.33-1.4,0.42 C56.98,236.345,56.49,236.395,56,236.395z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletSvgrepoCom);
export default __webpack_public_path__ + "static/media/wallet-svgrepo-com.d9c86199f19c38a9bed2893bd85d110a.svg";
export { ForwardRef as ReactComponent };